import styled, { css } from 'styled-components';
import { ChangeEvent } from 'react';
import circleOn from 'src/assets/images/btn_terms_on@3x.png';
import circleOff from 'src/assets/images/btn_terms_off@3x.png';
import lineOn from 'src/assets/images/v_terms_checked-red.png';
import lineOff from 'src/assets/images/v_terms.png';

const CheckBoxWrap = styled.label`
  display: flex;
  align-items: center;
  user-select: none;

  > input[type='checkbox'] {
    cursor: pointer;
    /* removing default appearance */
    //-webkit-appearance: none;
    //appearance: none;
  }
`;

const CheckBoxInput = styled.input<{ checkType: 'circle' | 'line' }>`
  appearance: none;
  width: 20px;
  height: 20px;

  ${(props) =>
    props.checkType === 'circle' &&
    css`
      background: url('${circleOff}') no-repeat;
      background-size: auto 20px;
    `}

  ${(props) =>
    props.checkType === 'line' &&
    css`
      background: url('${lineOff}') no-repeat;
      background-size: auto 13px;
      background-position: 0 4px;
    `}

  &:checked {
    ${(props) =>
      props.checkType === 'circle' &&
      css`
        background: url('${circleOn}') no-repeat;
        background-size: auto 20px;
      `}

    ${(props) =>
      props.checkType === 'line' &&
      css`
        background: url('${lineOn}') no-repeat;
        background-size: auto 13px;
        background-position: 0 4px;
      `}
  }
`;
const CheckBoxSpan = styled.span`
  padding-left: 10px;
`;

interface CheckBoxProps {
  onChange: (e: ChangeEvent<HTMLInputElement>, k: number | undefined) => void;
  onClick?: () => void;
  label: string;
  type: 'circle' | 'line';
  checked: boolean;
  id?: number;
}

const CheckBox = (props: CheckBoxProps) => {
  const { type, checked, id, label, onClick, onChange } = props;
  return (
    <CheckBoxWrap>
      <CheckBoxInput
        type="checkbox"
        checkType={type}
        checked={checked}
        onChange={(e) => onChange(e, id)}
      />
      <CheckBoxSpan onClick={onClick}>{label}</CheckBoxSpan>
    </CheckBoxWrap>
  );
};

export default CheckBox;
